module.exports = __webpack_public_path__ + "static/media/fbi.42c27429.jpg";